import { RefreshCw } from "lucide-react";
import type { Notify } from "./admin-types";
import { Header, EmptyState } from "./AdminPagePrimitives";
import { formatDate } from "./admin-presentation";

import { useAdminSessionsWorkspace } from "./useAdminSessionsWorkspace";

export function SessionsPage({notify}: {notify: Notify}) {
  const { rows, load, revoke } = useAdminSessionsWorkspace({notify});
  return (
    <>
      <Header
        eyebrow="Oturum güvenliği"
        title="Aktif Oturumlar"
        description="Süresi dolmamış uygulama oturumlarını görüntüleyin ve gerektiğinde sonlandırın."
        action={
          <button className="secondary-button" onClick={load}>
            <RefreshCw size={15} /> Yenile
          </button>
        }
      />
      <section className="module-card">
        {rows.length ? (
          <div className="data-table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Kullanıcı</th>
                  <th>Cihaz</th>
                  <th>Son aktivite</th>
                  <th>Bitiş</th>
                  <th aria-label="İşlem" />
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <strong>{row.user_name}</strong>
                      <small>{row.email}</small>
                    </td>
                    <td>{row.user_agent ?? "Bilinmeyen cihaz"}</td>
                    <td>{formatDate(row.last_seen_at)}</td>
                    <td>{formatDate(row.expires_at)}</td>
                    <td>
                      <button
                        className="row-action danger"
                        onClick={() => revoke(row)}
                      >
                        Sonlandır
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <EmptyState
            title="Aktif oturum bulunmuyor"
            description="Yeni bir kurumsal giriş yapıldığında oturum burada görünecek."
          />
        )}
      </section>
    </>
  );
}
